// ============================================================================
// useOperadorFinanceiro — a sessão opera o Financeiro? (06/10/2026)
// ============================================================================
// Decisão do dono: o Financeiro (e a Folha, dentro dele) é só de quem está na
// LISTA FECHADA do servidor (api/_lib/fin-operadores.js: master + contas
// liberadas — "por enquanto eu; depois a Fernanda, do administrativo"). A
// recepção continua com Caixas/Comandas pelo cargo (fora deste hook).
//
// Sem cópia da lista aqui: quem decide é o SERVIDOR. O /api/folha-recibos
// ?op=acesso devolve podePublicar = operador financeiro (mesma lista), e o
// useRecibosAcesso já cuida de cache por sessão, chamadas simultâneas e
// re-tentativa. O master é operador sempre (no servidor também), então nem
// pergunta — sem espera pra ele.
//
// Sem flash: enquanto o servidor não responde, operador=false (loading=true).
// FALHA ≠ "não é operador" (REGRA LINEAR): erro volta em `erro` e o
// useRecibosAcesso tenta de novo sozinho; a tela decide se mostra aviso.
//
// Uso: const { loading, operador, erro, recarregar } = useOperadorFinanceiro();
//      useOperadorFinanceiro({ enabled: false }) → não chama a API (operador=false).
// ============================================================================

import { useAuth } from '../contexts/AuthContext.jsx';
import { useRecibosAcesso } from './useRecibosAcesso.js';

export function useOperadorFinanceiro({ enabled = true } = {}) {
  const { isMaster } = useAuth();
  const perguntar = enabled && !isMaster;
  const acesso = useRecibosAcesso({ enabled: perguntar });
  if (!enabled) return { loading: false, operador: false, erro: '', recarregar: acesso.recarregar };
  if (isMaster) return { loading: false, operador: true, erro: '', recarregar: acesso.recarregar };
  return {
    loading: !!acesso.loading,
    operador: acesso.podePublicar === true,
    erro: acesso.erro || '',
    recarregar: acesso.recarregar,
  };
}

export default useOperadorFinanceiro;
